<template>
  <div v-loading="loading">
    <div class="dwp-font-bold dwp-text-xl dwp-border-b dwp-border-gray-200 dwp-pb-4">
      {{list.title}}
      <span
        class="dwp-font-normal dwp-text-gray-600 dwp-text-sm dwp-ml-1"
      >{{ project.name }}</span>
    </div>
    <div
      v-for="task in active"
      :key="task.id"
      class="dwp-flex dwp-py-4 dwp-space-x-3 dwp-border-b dwp-border-gray-200 dwp-text-gray-700"
    >
      <Checkbox :checked="false" />
      <div>{{ task.title }}</div>
    </div>
    <div
      v-for="task in done"
      :key="task.id"
      class="dwp-flex dwp-py-4 dwp-space-x-3 dwp-border-b dwp-border-gray-200 dwp-text-green-600 dwp-line-through"
    >
      <Checkbox :checked="true" />
      <div>{{ task.title }}</div>
    </div>
  </div>
</template>

<script>
import Checkbox from "@/components/Checkbox.vue";
import { sync, get } from "vuex-pathify";

export default {
  props: {
    list: Object,
  },

  data() {
    return {
      loading: false,
    };
  },

  components: {
    Checkbox,
  },

  computed: {
    project: get("project/project"),
    active() {
      return this.$store.getters["tasks/activeOrdered"](this.list);
    },
    done() {
      return this.$store.getters["tasks/doneOrdered"](this.list);
    },
    showCompleted: get("ui/showCompleted"),
  },

  async mounted() {
    this.loading = true;
    console.log(this.project);
    await this.$store.dispatch("tasks/bindDone", this.list.id);
    this.loading = false;
  },

  // return to normal
  async beforeDestroy() {
    if (!this.showCompleted) {
      await this.$store.dispatch("tasks/bindTasks", { clearModule: true });
    }
  },
};
</script>